// ==============================|| DRAWER HEADER - STYLED ||============================== //

const DrawerHeaderStyled = ({ open, children, ...other }) => {
  return (
    <div
      {...other}
      className="flex items-center w-full"
      style={{
        justifyContent: 'center',
        padding: '8px 0',
      }}
    >
      {children}
    </div>
  );
};

export default DrawerHeaderStyled;
